import { useState, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import "./App.css";
import Landing from "./components/main/landing";
import Login from "./components/Accounts/login/login";
import Started from "./components/started/started";
import Signup from "./components/Accounts/signup/signup";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./config";


function App() {
  const [currentUser, setCurrentUser] = useState("")
  const navigate = useNavigate();
  // useEffect(() => {
  //   // const auth = getAuth();
  //   const unsubscribe = onAuthStateChanged(auth, (user) => {
  //     if (user) {
  //       // User is signed in.
  //       const { uid } = user;
  //       navigate("/");
  //       setCurrentUser(user.displayName)
  //       // setUserisLogged(true);
  //     } else {
  //       navigate("/login")
  //       // User is signed out.
  //       // setUserisLogged(false);

  //       // router.push({
  //       //     pathname: "/login",
  //       // });
  //     }
  //   });
  //   return () => unsubscribe();
  // }, []);
  return (
    <div className="App">
      <ToastContainer />

      <Routes>
        <Route path="/" exact element={<Landing currentUser={currentUser} />} />
        <Route path="/login" exact element={<Login />} />
        <Route path="/signup" exact element={<Signup />} />
        <Route path="/started" exact element={<Started />} />
      </Routes>

    </div>
  );
}

export default App;
